module.exports = __webpack_public_path__ + "img/allow-right.f2a15984.svg";